<template>
  <div class="traceability-data-table">
    <data-table :header="table.header">
      <TraceabilitySampleView
        v-for="(item, index) in groupedExams"
        :key="index"
        :order-index="index"
        :body="item"
        :redirect-after-exclude-exam="redirectAfterExcludeExam"
        class="data-table__body__row"
        @openMapModal="openMap"
        @examIncluded="handleExamIncluded"
        @afterExcludeExam="handleAfterExcludeExam"
      />
    </data-table>

    <modal-map
      :batch-barcode="sampleInMap.lotId"
      :o-s-alvaro="OSAlvaroInMap"
      :exam-name="examInMap?.codeExamBrand"
      :place-execution-id="examInMap?.idDestination"
      :laboratory-localization="{
        latitude: examInMap?.latitude,
        longitude: examInMap?.longitude,
      }"
    />

    <infinite-loading
      slot="append"
      ref="infiniteLoading"
      force-use-infinite-wrapper=".data-table__header"
      @infinite="handleNextPage"
    >
      <span slot="no-more" />
      <span slot="no-results" />
      <span slot="spinner">
        <spinner />
      </span>
    </infinite-loading>
  </div>
</template>

<script>
import InfiniteLoading from 'vue-infinite-loading'
import DataTable from '../common/dataTable/DataTable'
import ModalMap from './ModalMap'
import spinner from '../common/Spinner'
import TraceabilitySampleView from './TraceabilitySampleView.vue'
import TraceabilityModalStatus from './TraceabilityModalStatus.vue'
import { mapGetters, mapActions } from 'vuex'

export default {
  name: 'TraceabilityDataTable',
  components: {
    ModalMap,
    DataTable,
    spinner,
    TraceabilityModalStatus,
    InfiniteLoading,
    TraceabilitySampleView,
  },
  props: {
    groupedExams: {
      type: Array,
      required: false,
      default: () => [],
    },
    redirectAfterExcludeExam: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      table: {
        header: [
          {
            title: 'OS Álvaro / LIS',
            size: 25,
          },
          {
            title: 'Paciente',
            size: 35,
          },
          {
            title: 'Amostras',
            subtitle: 'Destinos',
            size: 20,
          },
          {
            component: TraceabilityModalStatus,
            size: 20,
          },
        ],
      },
      OSAlvaroInMap: null,
      examInMap: {},
      sampleInMap: {},
      internalGroupedExams: [],
    }
  },
  computed: {
    ...mapGetters(['traceabilityCurrentTab', 'traceabilityHasNext']),
    hasNext() {
      return this.traceabilityHasNext
    },
  },
  watch: {
    traceabilityCurrentTab(newVal, oldValue) {
      if (newVal !== oldValue) {
        this.$nextTick(() => {
          if (this.$refs.infiniteLoading) {
            this.$refs.infiniteLoading.stateChanger.reset()
          }
        })
      }
    },
  },
  methods: {
    ...mapActions(['setTraceabilityMapModalVisible']),
    openMap({ orderId, sample }) {
      const examInTransit =
        sample.exams?.find(
          exam =>
            exam.currentStatus === 'EM_TRANSITO' ||
            exam.currentStatus === 'EM_TRANSITO_ENTRE_NTO'
        ) || sample.exams?.[0]

      this.examInMap = examInTransit
      this.OSAlvaroInMap = orderId
      this.sampleInMap = sample
      this.setTraceabilityMapModalVisible(true)
    },
    handleExamIncluded({ orderId, examData }) {
      this.$emit('examIncluded', { orderId, examData })
    },
    handleNextPage($state) {
      this.$emit('nextPage', $state)
    },
    handleAfterExcludeExam() {
      this.$emit('afterExcludeExam')
    },
  },
}
</script>

<style lang="scss" scoped>
.traceability-data-table {
  font-family: 'Exo 2', sans-serif !important;

  .data-table__body__row {
    font-family: 'Exo 2', sans-serif !important;
    cursor: pointer;
    margin-bottom: 0.5rem;

    &__cell {
      font-family: 'Exo 2', sans-serif !important;
      margin: 0;

      button {
        width: 30%;
        padding-right: 0px;
        padding-bottom: 18px;

        .md-icon {
          margin: 0;
        }
      }

      h3.text-capitalize {
        text-transform: capitalize !important;
      }
    }
  }

  .subtable .data-table__header__row__cell {
    padding-top: 0px !important;

    &:nth-child(4),
    &:last-child {
      text-align: right;
      padding-right: 24px !important;
    }
  }

  ::v-deep(.data-table__header__row__cell) {
    padding: 16px;
  }

  .loader-details {
    height: 10px;
    width: 10px;
    margin-top: 0.8em;
  }

  .status {
    font-weight: 500;
    display: flex;
    flex-direction: row;
    margin-top: 2px;

    p {
      display: flex;
      font-size: 14px;
      width: 75%;
      margin-top: 2px;
    }

    .button-open-map {
      cursor: pointer;

      &:hover,
      &:focus {
        .md-icon > svg {
          .pin {
            fill: #7f1a54;
            transition: 0.5s;
          }
        }
      }
    }

    .md-icon {
      margin: 0 auto;
    }

    .bullet {
      margin-right: 0.5em;
      font-size: 25px;
      font-weight: bold;
    }
  }
}
</style>
